import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { apiUrl, BaseUrls } from '@app/app.constants';
import { CallCenter } from '@app/core/interfaces/c5/acd/call-center';
import { Queue } from '@app/core/interfaces/c5/acd/queue';
import { QueueAgent } from '@app/core/interfaces/c5/acd/queue-agent';
import { UserLevel } from '@app/core/models/user-level';
import { Utils } from '@app/shared/services/utils.service';
import { wrapError } from '@app/utils/rxjs';
import { CallCenterAndQueueWithUser } from '@business/call-center/models/call-center-and-queue-with-user';
import { Observable } from 'rxjs';
import { mergeMap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class CallCenterRepository {
  constructor(
    private http: HttpClient,
    private utils: Utils
  ) {}

  get(): Observable<CallCenter> {
    const urls = {
      [UserLevel.EnterpriseAdmin]: BaseUrls.ServiceProvider.Enterprise + '/callCenter',
      [UserLevel.ServiceProviderAdmin]: BaseUrls.ServiceProvider.Enterprise + '/callCenter',
    };

    return this.utils.apiUrl(urls).pipe(
      mergeMap((url) => this.http.get<CallCenter>(url)),
      wrapError('call-center-repository:get')
    );
  }

  getEndUserAgents(): Observable<QueueAgent[]> {
    return this.http
      .get<QueueAgent[]>(apiUrl('/user/callCenter/agent'))
      .pipe(wrapError('call-center-repository:get-end-user-agents'));
  }

  getQueue(callCenterId: number, queueId: number): Observable<CallCenterAndQueueWithUser> {
    return this.utils.apiUrl(`/callCenter/${callCenterId}/queue/${queueId}`).pipe(
      mergeMap((url) => this.http.get<CallCenterAndQueueWithUser>(url)),
      wrapError('call-center-repository:get-queue')
    );
  }

  listQueues(callCenterId: number): Observable<Queue[]> {
    return this.utils.apiUrl(`/callCenter/${callCenterId}/queue`).pipe(
      mergeMap((url) => this.http.get<Queue[]>(url)),
      wrapError('call-center-repository:list-queues')
    );
  }

  update(callCenter: CallCenter): Observable<void> {
    return this.utils.apiUrl('/callCenter').pipe(
      mergeMap((url) => this.http.put<void>(url, callCenter)),
      wrapError('call-center-repository:update')
    );
  }

  updateQueue(callCenterId: number, queueId: number, queue: Queue): Observable<void> {
    return this.utils.apiUrl(`/callCenter/${callCenterId}/queue/${queueId}`).pipe(
      mergeMap((url) => this.http.put<void>(url, queue)),
      wrapError('call-center-repository:update-queue')
    );
  }
}
